import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfinity } from "@fortawesome/free-solid-svg-icons";
import {
  faYoutube,
  faXTwitter,
  faInstagram,
  faReddit,
  faThreads,
  faFacebook,
  faPinterest,
  faQuora,
} from "@fortawesome/free-brands-svg-icons";

export const renderPlatformIcon = (platform) => {
  switch ((platform || "").toUpperCase()) {
    case "ALL":
      return (
        <FontAwesomeIcon
          icon={faInfinity}
          style={{
            width: "26px",
            height: "26px",
            fontSize: "26px",
            color: "url(#purpleGradient)",
            background: "linear-gradient(135deg, #7e5bef, #a978f9)",
            borderRadius: "50%",
            padding: "10px",
            margin: "6px",
          }}
          title="All Platforms"
        />
      );
    case "FACEBOOK":
      return (
        <FontAwesomeIcon
          icon={faFacebook}
          style={{
            fontSize: "28px",
            color: "#4267B2",
            backgroundColor: "#E9F1FB",
            borderRadius: "50%",
            padding: "10px",
            margin: "6px",
          }}
          title="Facebook"
        />
      );
    case "TWITTER":
      return (
        <FontAwesomeIcon
          icon={faXTwitter}
          style={{
            width: "26px",
            height: "26px",
            fontSize: "26px",
            color: "#ffffff",
            backgroundColor: "#000000",
            borderRadius: "50%",
            padding: "10px",
            margin: "6px",
          }}
          title="Twitter"
        />
      );
    case "YOUTUBE":
      return (
        <div
          style={{
            width: "52px",
            height: "48px",
            backgroundColor: "#FFEBEB",
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "6px",
          }}
          title="YouTube"
        >
          <FontAwesomeIcon
            icon={faYoutube}
            style={{
              fontSize: "28px",
              color: "#FF0000",
            }}
          />
        </div>
      );
    case "INSTAGRAM":
      return (
        <FontAwesomeIcon
          icon={faInstagram}
          style={{
            width: "28px",
            fontSize: "28px",
            color: "#E4405F",
            backgroundColor: "#FDECEF",
            borderRadius: "50%",
            padding: "10px",
            margin: "6px",
          }}
          title="Instagram"
        />
      );
    case "THREADS":
      return (
        <FontAwesomeIcon
          icon={faThreads}
          style={{
            width: "26px",
            height: "26px",
            fontSize: "26px",
            color: "#ffffff",
            backgroundColor: "#000000",
            borderRadius: "50%",
            padding: "10px",
            margin: "6px",
          }}
          title="Threads"
        />
      );
    case "REDDIT":
      return (
        <FontAwesomeIcon
          icon={faReddit}
          style={{
            width: "26px",
            height: "26px",
            fontSize: "26px",
            color: "#FF4500",
            backgroundColor: "#FFEDE5",
            borderRadius: "50%",
            padding: "10px",
            margin: "6px",
          }}
          title="Reddit"
        />
      );
    case "PINTEREST":
      return (
        <FontAwesomeIcon
          icon={faPinterest}
          style={{
            width: "26px",
            height: "26px",
            fontSize: "26px",
            color: "#E60023",
            backgroundColor: "#FFF0F0",
            borderRadius: "50%",
            padding: "10px",
            margin: "6px",
          }}
          title="Pinterest"
        />
      );
    case "QUORA":
      return (
        <FontAwesomeIcon
          icon={faQuora}
          style={{
            width: "26px",
            height: "26px",
            fontSize: "26px",
            color: "#B92B27",
            backgroundColor: "#FDECEA",
            borderRadius: "50%",
            padding: "10px",
            margin: "6px",
          }}
          title="Quora"
        />
      );
    default:
      return (
        <span
          style={{
            margin: "0 6px",
            color: "rgba(0, 0, 0, 0.7)",
            fontStyle: "italic",
          }}
        >
          {platform || "Unknown"}
        </span>
      );
  }
};
